<template>
  <div class="root ma-2">
    <v-card>
      <v-progress-linear indeterminate striped v-if="loading"></v-progress-linear>
      <v-card-title>Change Password</v-card-title>
      <v-card-text>
        <AAlert :alert="alert"></AAlert>
        <v-alert class="text-left" color="error" text v-if="alert && alert.length > 0">{{alert}}</v-alert>
        <v-form ref="refForm" @submit="submit">
          <div class="column card">
            <v-text-field
              v-model="form.currentPassword"
              :rules="rules"
              label="Current Password"
              type="password"
              outlined
            ></v-text-field>
            <v-text-field
              v-model="form.newPassword"
              :rules="rules"
              label="New Password"
              type="password"
              outlined
            ></v-text-field>
            <v-text-field
              v-model="form.newPasswordVerification"
              :rules="rules"
              label="Re-enter New Password"
              type="password"
              outlined
            ></v-text-field>
            <v-btn color="error" @click="submit">change</v-btn>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { setTimeout } from "timers";
import snackbar from "../../mixins/snackbar";
import AAlert from "../../components/AAlert";
import authApi from "../../api/auth";
import axios from "../../api/axios";


export default {
  components: {
    AAlert
  },
  data() {
    return {
      loading: false,
      form: {
        currentPassword: "",
        newPassword: "",
        newPasswordVerification: ""
      },
      rules: [
        v => !!v || "Field Empty",
        v => (v && v.length >= 6) || "Name must be atleast 5 characters"
      ],
      alert: {}
    };
  },
  methods: {
    submit() {
      this.alert = "";
      if (this.$refs.refForm.validate()) {
        this.loading = true;
        axios.post("/account/change-password", this.form).then(r => {
          this.loading = false;
          this.alert = r.data;
        });
      }
    }
  }
};
</script>

<style scoped>
.root {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.card {
  padding: 10px;
  width: 500px;
  background-color: white;
  color: #555555;
}
</style>
